import axios from 'axios';

const root = userId => (userId ? `/backoffice/user/${userId}/bank_proofs/` : '/bank_proofs/');

export const listBankProofs = (userId, status) => axios.get(root(userId), { params: status ? { status } : {} });

export const uploadBankProof = (file, replaces) => {
  const data = new FormData();
  data.append('file', file);
  return axios.post(`${root()}${replaces ? `${replaces}/replace/` : ''}`, data);
};

export const archiveBankProof = id => axios.post(`${root()}${id}/archive/`);
export const reviewBankProof = (userId, id, action, reason) =>
  axios.post(`${root(userId)}${id}/${action}/`, { reason });
export const getBankProofFile = (userId, id) =>
  axios.get(`/backoffice/user/${userId}/bank_proofs/${id}/file/`, { responseType: 'blob' });
